<div class="wrapper mb-5">
    <div class="row title-container align-items-center" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg" />
        <span class="label-title ml-2 mr-3">
            Cadastro de Favorecidos via arquivo</span
        >
    </div>

    <div class="component-box my-0 alert alert-light" role="alert">
        <div class="row p-3">
            <div class="p-0 mx-3 align-self-center">
                <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
            </div>
            <div class="col-11 p-0 m-0 align-self-center">
                <p class="m-0">
                    Os colaboradores serão listados na aba 'Cadastro > Favorecidos' quando os dados forem processados.
                    <!-- <strong>Por que solicitamos a chave PIX da sua empresa?</strong>
                    <br>Em eventuais estornos ou devoluções de recursos da Bankei para a sua empresa, será utilizada a chave PIX.
                    <br>A chave PIX deve ser obrigatória e de titularidade da sua empresa. -->
                </p>
            </div>
        </div>
    </div>

    <div class="component-box container-fluid m-0 p-0 rounded-bottom mt-3">
        <div class="row p-5">
            <div class="col-12 p-0">
                <div class="bar-background"></div>
                <div class="bar-progress" [style.width.%]="progressBarValue"></div>
                <p class="mt-2">
                    {{ status.processada }} processados de {{ status.total }}
                </p>
            </div>

            <div *ngIf="processed && status.erro > 0" class="col-12 button-container mt-3 p-0">
                <p class="mt-2 mb-2">
                    Encontramos alguns dados incorretos na tabela.
                    <br>
                    Baixe o arquivo e corrija os erros indicados na última coluna.
                </p>
            </div>
            <div class="col-12 button-container text-right mt-2 mb-3 p-0">
                <button (click)="baixarErros()" class="btn-error action-button h-auto mt-0" *ngIf="processed && status.erro > 0">
                    Baixar arquivo com erros
                </button>

                <button (click)="cardsBacth()" class="action-button h-auto mt-0" [disabled]="!processed">
                    Conceder produtos
                </button>
            </div>
        </div>
    </div>
</div>
